import { AnimatePresence, motion } from "framer-motion";

export const WelcomeSplash = ({ show }) => (
  <AnimatePresence>
    {show && (
      <motion.div key="welcome" data-testid="welcome-splash" initial={{ opacity: 1 }} exit={{ opacity: 0, transition: { duration: 0 } }}
        className="grain fixed inset-0 z-[80] flex flex-col bg-[#0A0A0A] text-white">
        <div aria-hidden className="pointer-events-none absolute inset-0 opacity-[0.07]" style={{ backgroundImage: "repeating-linear-gradient(135deg, #fff 0 1px, transparent 1px 22px)" }} />
        <div className="relative mx-auto flex w-full max-w-7xl flex-1 flex-col justify-center px-5 sm:px-10">
          <img src="/assets/logo-dark.png" alt="Cresway Media logo" className="h-16 w-16 object-contain sm:h-20 sm:w-20" data-testid="welcome-splash-logo" />
          <p className="mt-8 font-mono-label text-xs uppercase tracking-[0.25em] text-zinc-300">Welcome to</p>
          <h1 className="mt-3 font-display text-5xl font-extrabold leading-[0.95] tracking-[-0.04em] sm:text-7xl lg:text-8xl" data-testid="welcome-splash-heading">
            Cresway <em className="font-serif-accent font-normal italic text-[#E62314]">Media</em>
          </h1>
          <p className="mt-5 max-w-md text-base text-zinc-300 sm:text-lg">Come on in, we're glad you're here.</p>
          <div className="mt-10 h-[3px] w-full max-w-sm overflow-hidden bg-white/15" role="progressbar" aria-label="Loading">
            <motion.div className="h-full bg-[#E62314]" initial={{ width: "8%" }} animate={{ width: "100%" }} transition={{ duration: 3, ease: [0.45, 0, 0.25, 1] }} />
          </div>
        </div>
      </motion.div>
    )}
  </AnimatePresence>
);
